import React from 'react'
import PropTypes from 'prop-types'
import LoaderButton from 'commons/js/ui/LoaderButton'
import messages from './messages'
import { injectIntl } from 'react-intl'
import { LocalForm } from 'commons/js/components/form'
import { Flex, Box, Copy, ReCaptcha } from '@elparking/components'

import ContactField from './ContactField'
import { ErrorMessage, SuccessMessage } from 'commons/js/ui/ResponseMessage'

import {
    trackSendContactForm,
} from 'commons/js/services/analytics'
class ContactForm extends React.Component {
    state = {
        loading: false,
        error: false,
        success: false,
        reCaptcha: null,
        reCaptchaKey: 0,
        loadingCaptcha: true,
    };

    static propTypes = {
        intl: PropTypes.object,
        onSubmit: PropTypes.func,
        fieldsRow: PropTypes.array,
        source: PropTypes.string,
        sitekey: PropTypes.string,
        contactFieldElement: PropTypes.func,
    };

    static defaultProps = {
        onSubmit: () => {},
        fieldsRow: [],
        source: '',
        contactFieldElement: ContactField,
    };

    refreshReCaptcha () {
        const { reCaptchaKey } = this.state
        this.setState({ reCaptchaKey: reCaptchaKey + 1, loadingCaptcha: true })
    }

    refreshReCaptcha = this.refreshReCaptcha.bind(this)

    onSubmit = this.onSubmit.bind(this);
    onSubmit (values) {
        const { reCaptcha } = this.state
        const { source } = this.props
        this.setState(
            () => ({ loading: true }),
            () => {
                this.props
                    .onSubmit({ ...values, reCaptcha, source })
                    .then(this.onSuccess)
                    .catch(this.onReceiveErrors)
                    .finally(this.refreshReCaptcha)
            },
        )
    }

    onSuccess = this.onSuccess.bind(this);
    onSuccess ({ error: errors }) {
        const success = !errors
        trackSendContactForm({url: window.location.pathname})
        this.setState({ loading: false, error: !success, success, reCaptchaKey: this.state.reCaptchaKey + 1 })
    }

    onReceiveErrors = this.onReceiveErrors.bind(this);
    onReceiveErrors () {
        this.setState({ loading: false, error: true, reCaptchaKey: this.state.reCaptchaKey + 1 })
    }

    renderError () {
        return (
            <ErrorMessage>
                {this.props.intl.formatMessage(messages.error)}
            </ErrorMessage>
        )
    }

    renderSuccess () {
        return (
            <SuccessMessage>
                {this.props.intl.formatMessage(messages.success)}
            </SuccessMessage>
        )
    }

    verifyCallback (reCaptcha) {
        this.setState({ reCaptcha, loadingCaptcha: false })
    }
    verifyCallback = this.verifyCallback.bind(this);

    renderFields () {
        const {
            fieldsRow,
            contactFieldElement: ContactFieldElement,
        } = this.props
        return fieldsRow.map((fields, rowKey) => {
            return (
                <Flex
                  flexWrap='wrap'
                  justifyContent='space-between'
                  flex='1 0 100%'
                  key={rowKey}
                >
                    {fields.map((field, index) => {
                        const width = `${100 / fields.length}%`
                        const flexRow = `1 0 ${width}`
                        const padding = ['0', '4px', '4px']
                        return (
                            <Box
                              key={index}
                              flex={['1 0 100%', flexRow, flexRow]}
                              pl={index === 0 ? '0' : padding}
                              pr={index === fields.length ? '0' : padding}
                              pb='16px'
                            >
                                <ContactFieldElement field={field} />
                            </Box>
                        )
                    })}
                </Flex>
            )
        })
    }

    render () {
        const { intl, sitekey } = this.props
        const { loading, success, error, reCaptchaKey, loadingCaptcha } = this.state
        return (
            <LocalForm onSubmit={this.onSubmit} model='contactForm'>
                <Box w='100%' pb='24px'>
                    <Copy
                      size='small'
                      fontWeight='regular'
                      color='gray'
                      padding='0'
                    >
                        {intl.formatMessage(messages.header)}
                    </Copy>
                </Box>
                <Box w='100%'>{this.renderFields()}</Box>
                <Box w='100%'>
                    <LoaderButton
                      className='js-submit-contact-form'
                      dataTest='contact-form-send'
                      width='100%'
                      disabled={loading || success || loadingCaptcha}
                      loading={loading}
                    >
                        {intl.formatMessage(messages.send)}
                    </LoaderButton>
                </Box>
                <Box>
                    <ReCaptcha
                      key={`ReCaptchaContact_${reCaptchaKey}`}
                      sitekey={sitekey}
                      action='contactform'
                      callback={this.verifyCallback}
                    />
                </Box>
                {error && this.renderError()}
                {success && this.renderSuccess()}
            </LocalForm>
        )
    }
}

export default injectIntl(ContactForm)
